import { render, staticRenderFns } from "./OMSRulesSimple.vue?vue&type=template&id=337eb928"
import script from "./OMSRulesSimple.vue?vue&type=script&lang=js"
export * from "./OMSRulesSimple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports